import {getCookie} from "./getCookie";

export function showCookieBar() {
	
	const $body = $("body");
	const $cookieBar = $(".cookie-bar");
	const $closeBtn = $cookieBar.find(".learn-more");

    const domainName = window.location.hostname;
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + (30 * 24 * 60 * 60 * 1000));

    let key = "showCookieBar=true; path=/; domain=" + domainName + "; expires=" + expiry.toGMTString() + ";";
	
	$(window).on("load", () => {

        if(!getCookie("showCookieBar")) {
            $body.addClass("show-cookie");
        }
	});
	
	$closeBtn.on("click", () => {
		$body.removeClass("show-cookie");
		document.cookie = key;
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/cookie-bar.js